import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import TemplateLayout from '../../Commons/TemplateLayout';
import { useContext, useMemo, useState } from 'react';
import { createProjectTemplate } from '../../../../../../services/api/projectTemplates';
import { MainContext } from '../../../../../../context/MainContext';
import { useIntl } from 'react-intl';
import SuccessPage from '../../Commons/TemplateLayout/components/SuccessPage';
import LaboratoryFormFields from '../Commons/LaboratoryFormFields';
import { saveLaboratory } from '../../../../../../services/api/laboratory';
import regionNames from '../Commons/regionsNames';

const REGIONS = regionNames.map((col, index) => {
  return {
    x: 0,
    y: 0,
    width: 8,
    height: 3,
    isVisible: false,
    data: col,
    index: index,
  };
});

const CreateLaboratoryTemplate = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const { project } = useOutletContext();
  const { id } = useParams();
  const { setError, setLoading } = useContext(MainContext);
  const [success, setSuccess] = useState(false);
  const initialData = useMemo(
    () => ({ templateName: '', supplier_id: '', phone_number: '', email: '' }),
    [],
  );

  const createLaboratoryTemplate = async (regions, formState, fileName) => {
    try {
      setLoading(true);
      const regionIndex = regions.findIndex((reg) => reg.data === 'provider');
      const region = regions[regionIndex];
      regions.splice(regionIndex, 1);
      const laboratory = {
        name: formState.supplier_id,
        phone_number: formState.phone_number,
        email: formState.email,
      };
      const newLaboratory = await saveLaboratory(laboratory);
      const newTemplate = {
        name: formState.templateName,
        supplier: formState.supplier_id,
        model: 'laboratory',
        image: fileName.replace('pdf', 'png'),
        labId: newLaboratory.data.id,
        searchableRegion: {
          value: '',
          region: region,
        },
        regions: regions,
        pid: parseInt(id, 10),
      };
      const templateCreated = await createProjectTemplate(newTemplate);

      if (templateCreated.data) {
        setSuccess(true);
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <SuccessPage
        title={intl.formatMessage({
          id: 'pages.ocr.templates.laboratory.create.success.title',
        })}
        subtitle={intl.formatMessage({
          id: 'pages.ocr.templates.laboratory.create.success.subtitle',
        })}
        onBackToTemplates={() =>
          navigate(`/app/project/${project.id_project}/quality/ocr/templates`)
        }
      />
    );
  }

  return (
    <TemplateLayout
      topFormFields={<LaboratoryFormFields />}
      model="laboratory"
      initialData={initialData}
      regions={REGIONS}
      onFinish={createLaboratoryTemplate}
      onBack={() =>
        navigate(`/app/project/${project.id_project}/quality/ocr/templates`)
      }
    />
  );
};

export default CreateLaboratoryTemplate;
